import { MpviLineItem } from "types/MpviLineItem";

function getUnsuppressedLineItems(lineItems: MpviLineItem[]): MpviLineItem[]{
    // Get the line items that are not soft deleted.
    return lineItems.filter(lineItem => !lineItem.IsDeleted)
}

export default getUnsuppressedLineItems